import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const categoryLinks = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-user-3-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-checkbox-blank-circle-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-5-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-circle-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-crown-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navClasses = scrolled
    ? 'fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70 transition-all duration-300'
    : 'fixed top-0 left-0 right-0 z-50 bg-transparent transition-all duration-300';

  return (
    <nav className={navClasses}>
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-900 tracking-tight">
              kakobuypolska<span className="text-primary-500">.site</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.home')}
            </Link>

            <Link
              to="/artykul/kakobuy-dla-poczatkujacych"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.buyingGuide')}
            </Link>

            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 flex items-center gap-1.5 whitespace-nowrap cursor-pointer"
              >
                {t('nav.categories')}
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>

              {dropdownOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setDropdownOpen(false)}></div>
                  <div className="absolute top-full left-0 mt-1 w-72 bg-background-50 rounded-lg border border-background-200/70 shadow-sm z-50 py-2 max-h-96 overflow-y-auto">
                    {categoryLinks.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/30 transition-colors duration-150 whitespace-nowrap"
                        onClick={() => setDropdownOpen(false)}
                      >
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>

            <a
              href="#o-czym"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.spreadsheet')}
            </a>

            <a
              href="#bezpieczenstwo"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.safety')}
            </a>

            <a
              href="#poradniki"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.guides')}
            </a>

            <a
              href="#faq"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/50 transition-colors duration-200 whitespace-nowrap"
            >
              {t('nav.faq')}
            </a>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Kakobuy Spreadsheet
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer relative z-50"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="px-4 py-6 flex flex-col gap-1">
            <Link
              to="/"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className="ri-home-4-line text-base"></i>
              </span>
              {t('nav.home')}
            </Link>

            <Link
              to="/artykul/kakobuy-dla-poczatkujacych"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
                <i className="ri-book-open-line text-base"></i>
              </span>
              {t('nav.buyingGuide')}
            </Link>

            <div>
              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="w-full flex items-center justify-between gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150 cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500">
                    <i className="ri-grid-line text-base"></i>
                  </span>
                  {t('nav.categories')}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>

              {mobileCatOpen && (
                <div className="mt-1 ml-5 pl-4 border-l-2 border-primary-200 grid grid-cols-1 gap-0.5">
                  {categoryLinks.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2.5 px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 rounded-lg hover:bg-primary-50/20 whitespace-nowrap"
                      onClick={() => { setMobileCatOpen(false); setMobileMenuOpen(false); }}
                    >
                      <span className="w-6 h-6 flex items-center justify-center text-primary-400">
                        <i className={`${cat.icon} text-sm`}></i>
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="#o-czym"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className="ri-file-list-3-line text-base"></i>
              </span>
              {t('nav.spreadsheet')}
            </a>
            <a
              href="#bezpieczenstwo"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
                <i className="ri-shield-check-line text-base"></i>
              </span>
              {t('nav.safety')}
            </a>
            <a
              href="#poradniki"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500">
                <i className="ri-article-line text-base"></i>
              </span>
              {t('nav.guides')}
            </a>
            <a
              href="#faq"
              className="flex items-center gap-3 px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50/30 transition-colors duration-150"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
                <i className="ri-question-line text-base"></i>
              </span>
              {t('nav.faq')}
            </a>

            <div className="mt-4 pt-4 border-t border-background-200/70">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Kakobuy Spreadsheet
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}